
import https from './index'
import qs from 'qs'



// let buildStatus = 'dev'
let buildStatus = 'pro'
// let buildStatus = 'ov'
// // 测试环境






if(buildStatus == 'dev'){

  var rootApi = 'http://t-api.ansongqiubo.com' //测试环境
  var rootWs = 'ws://t-chat.ansongqiubo.com/websocketServer'//测试环境websocket
  var rootPay = 'http://t-pay-gateway.ansongqiubo.com' //测试环境充值
  var FansGroupUrl  = "http://t-fans.ansongqiubo.com";  // //接口
  var FansUpLoadUrl = "http://t-upload.ansongqiubo.com";//上传图片
  var FansGroupSocketUrl = "ws://t-wsfans.ansongqiubo.com/websocketServer";//socket
  var ScoreMatch  = "http://t-match.ansongqiubo.com";
  var ImgpagaUrl = 'https://lz-video.oss-cn-hangzhou.aliyuncs.com/'
  var ScopeSocketUrl = 'ws://121.43.108.148:2108/websocketServer'     // 比分socket

}else if(buildStatus == 'ov'){
  var rootApi = 'http://o-api.ansongqiubo.com' //测试环境
  var rootWs = 'wss://chat.ansongqiubo.com/websocketServer'//测试环境websocket
  var rootPay = 'https://pay-gateway.ansongqiubo.com' //测试环境充值
  var FansGroupUrl  = "http://o-fans.ansongqiubo.com";  // //接口
  var FansUpLoadUrl = "http://o-upload.ansongqiubo.com";//上传图片
  var FansGroupSocketUrl = "wss://swsfans.ansongqiubo.com/websocketServer"; // 粉丝群socket
  var ScopeSocketUrl = 'wss://wsmatch.ansongqiubo.com/websocketServer'     // 比分socket
  var ScoreMatch  = "http://o-match.ansongqiubo.com";  // 比赛基础
  var ImgpagaUrl = 'https://lz-video.oss-cn-hangzhou.aliyuncs.com/'
}else{
  var rootApi = 'https://api.ansongqiubo.com'  // 1
  var rootWs = 'wss://chat.ansongqiubo.com/websocketServer'  // 聊天2
  var rootPay = 'https://pay-gateway.ansongqiubo.com'    // 支付5
  var FansGroupUrl  = "https://fans.ansongqiubo.com";  // // 粉丝接口4
  var FansUpLoadUrl = "https://upload.ansongqiubo.com";//上传图片3
  var FansGroupSocketUrl = "ws://swsfans.ansongqiubo.com/websocketServer";//socket 粉丝群 6
  var ImgpagaUrl = 'https://lz-video.oss-cn-hangzhou.aliyuncs.com/'
  var ScoreMatch  = "https://match.ansongqiubo.com";   // 比分
  var ScopeSocketUrl = 'wss://wsmatch.ansongqiubo.com/websocketServer'     // 比分socket
}

if(buildStatus == 'dev'){
  // rootPay = 'lzpay'   // 测试环境打包去掉
}




// 正式环境





// 预发布
// let rootApi = 'http://o-api.ansongqiubo.com' //测试环境
// let rootWs = 'wss://chat.ansongqiubo.com/websocketServer'//测试环境websocket
// let rootPay = 'https://pay-gateway.ansongqiubo.com' //测试环境充值
// const FansGroupUrl  = "http://o-fans.ansongqiubo.com";  // //接口
// const FansUpLoadUrl = "http://o-upload.ansongqiubo.com";//上传图片
// const FansGroupSocketUrl = "wss://swsfans.ansongqiubo.com/websocketServer"; // 粉丝群socket
// const ScopeSocketUrl = 'wss://wsmatch.ansongqiubo.com/websocketServer'     // 比分socket
// const ScoreMatch  = "http://o-match.ansongqiubo.com";  // 比赛基础
// const ImgpagaUrl = 'https://lz-video.oss-cn-hangzhou.aliyuncs.com/'




// http://o-api.ansongqiubo.com
// http://o-upload.ansongqiubo
// http://o-fans.ansongqiubo
// http://o-match.ansongqiubo
// https://pay-gateway.ansongqiubo

// wss://chat.ansongqiubo.com
// wss://swsfans.ansongqiubo.com
// wss://wsmatch.ansongqiubo.com





export default {
	rootApi,
	rootWs,
  rootPay,
  ScoreMatch,
  ImgpagaUrl,
	FansGroupUrl,
	FansUpLoadUrl,
  ScopeSocketUrl,
	FansGroupSocketUrl,
}

function requestLog(data,url){
    console.log('%c [ 参数123123123 ]: ', 'color: #bf2c9f; background: pink; font-size: 13px;',data,rootApi + '/v1/envelope')
}



/**
 *
 * @param {roomId} params
 * @returns 房间号
 * @description  我的关注直播列表
 */
 export function relationlives (params) {
    return https({
        url:rootApi + '/v1/relation/lives',
        method: "get",
        params,
    })
}


//查找主播任务列表
export function getAnchorTask(params) {
  return https({
    url: FansGroupUrl + "/anchor/task/taskList",
    method: "get",
    params,
  });
}


/**
 *
 * @param {roomId} params
 * @returns
 * @description 获取版本强更新信息
 */
export function versioncontrol(params) {
    return https({
        url:rootApi + '/v1/device/versioncontrol',
        method: "get",
        params,
    })
}


/**
 *
 * @param {roomId} params
 * @returns
 * @description 获取固定热度包
 */
export function heatpackage(params) {
    return https({
        url:rootApi + '/v2/gift/heatpackage',
        method: "get",
        params,
    })
}


/**
 *
 * @param {roomId} params
 * @returns
 * @description 获取用户购买的固定热度包生效时长范围
 */
export function timheatpackage(params) {
    return https({
        url:rootApi + '/v2/gift/heatpackage/validtime',
        method: "get",
        params,
    })
}


/**
 *
 * @param {roomId} params
 * @description 购买固定热度包
 */
 export function buyheatpackage(data) {
    return https({
        url:rootApi + '/v2/gift/heatpackage',
        method: "POST",
        data:qs.stringify(data),
    })
}


/**
 *
 * @param {roomId} params
 * @description 离开直播间
 */
 export function roomleave(data) {
    return https({
        url:rootApi + '/v1/room/leave',
        method: "POST",
        data:qs.stringify(data),
    })
}


/**
 *
 * @param {roomId} params
 * @returns
 * @description 查询全部直播内容
 */
export function streamsAll(params) {
    return https({
        url:rootApi + '/v2/list/streams',
        method: "get",
        authToken:true,
        params,
    })
}



/**
 *
 * @param {roomId} params
 * @returns
 * @description 观看记录
 */
export function historystreamsAll(params) {
    return https({
        url:rootApi + '/v1/list/history',
        method: "get",
        authToken:true,
        params,
    })
}

/**
 *
 * @param {roomId} params
 * @description 阿里支付
 */
 export function paymentAli(data) {
    return https({
        url:rootPay + '/v1/payment/trade',
        method: "POST",
        data:qs.stringify(data),
    })
}
/**
 *
 * @param {roomId} params
 * @returns 房间号
 * @description 支付结果查询
 */
 export function paymentresult(params) {
    return https({
        url:rootPay + '/v1/payment/result',
        method: "get",
        params,
    })
}



/**
 *
 * @param {roomId} params
 * @description 修改房管-v2
 */
 export function roomEdit(data) {
    return https({
        url:rootApi + '/v2/manage/room/edit',
        method: "post",
        data:qs.stringify(data),
    })
}


/**
 *
 * @param {roomId} params
 * @description 移除房管-v2
 */
 export function roomRemove(data) {
    return https({
        url:rootApi + '/v2/manage/room/remove',
        method: "post",
        data:qs.stringify(data),
    })
}

/**
 *
 * @param {roomId} params
 * @description 添加房管-v2
 */
 export function roomAdd(data) {
    return https({
        url:rootApi + '/v2/manage/room/add',
        method: "post",
        data:qs.stringify(data),
    })
}

/**
 *
 * @param {roomId} params
 * @returns 房间号
 * @description 获取用户的角色权限
 */
 export function useroperation(params) {
    return https({
        url:rootApi + '/v2/manage/user/operation',
        method: "get",
        params,
    })
}


/**
 *
 * @param {roomId} params
 * @description 通用-发短信验证码(不包含登录)
 */
 export function sendSmsCode(data) {
    return https({
        url:rootApi + '/v2/common/sendSmsCode',
        method: "post",
        data:qs.stringify(data),
    })
}



/**
 *
 * @param {roomId} params
 * @description 通用-修改手机号
 */
 export function modifyMobile(data) {
    return https({
        url:rootApi + '/v2/profile/modifyMobile',
        method: "post",
        data:qs.stringify(data),
    })
}



/**
 *
 * @param {roomId} params
 * @description 通用-绑定支付宝
 */
 export function bindAliPay(data) {
    return https({
        url:rootApi + '/v2/profile/bind/aliPay',
        method: "post",
        data:qs.stringify(data),
    })
}


/**
 *
 * @param {roomId} params
 * @description 通用-绑定银行卡
 */
 export function bandCard(data) {
    return https({
        url:rootApi + '/v2/profile/bind/bankcard',
        method: "post",
        data:qs.stringify(data),
    })
}

/**
 *
 * @param {roomId} params
 * @description 通用-修改手机号
 */
 export function updatepassword(data) {
    return https({
        url:rootApi + '/v2/profile/password',
        method: "post",
        data:qs.stringify(data),
    })
}
/**
 *
 * @param {roomId} params
 * @description 校验手机号
 */
 export function checkSmsCode(data) {
    return https({
        url:rootApi + '/v2/common/checkSmsCode',
        method: "post",
         data:qs.stringify(data),
    })
}



/**
 *
 * @param {roomId} params
 * @description 获取用户基本信息
 */
 export function profileuser(params) {
    return https({
        url:rootApi + '/v1/profile/user',
        method: "get",
        params,
    })
}

/**
 *
 * @param {roomId} params
 * @description  解绑
 */
 export function unbindThird(data) {
    return https({
        url:rootApi + '/v2/third/unbindThird',
        method: "post",
        data:qs.stringify(data),
    })
}


/**
 *
 * @param {roomId} params
 * @description  一键登录
 */
 export function thirdlogin(data) {
    return https({
        url:rootApi + '/v2/third/login',
        method: "post",
        data:qs.stringify(data),
    })
}


/**
 *
 * @param {roomId} params
 * @returns 房间号
 * @description 余额
 */
 export function walletinfo(params) {
    return https({
        url:rootApi + '/v2/wallet/info',
        method: "get",
        params,
    })
}
/**
 *
 * @param {roomId} params
 * @returns 房间号
 * @description 账号安全-已完成显示
 */
 export function profilefinish(params) {
    return https({
       url:rootApi + '/v2/user/profile/finish',
       method: "get",
       params,
    })
}

/**
 *
 * @param {roomId} params
 * @description 个人中心绑定三方账号
 */
 export function bindThird(data) {
    return https({
        url:rootApi + '/v2/third/bindThird',
        method: "post",
        data,
    })
}
/**
 *
 * @param {roomId} params
 * @returns 房间号
 * @description 通用文件上传
 */
 export function deviceuploadfile(data) {
    return https({
        url:rootApi + '/v2/common/uploadfile',
        method: "post",
       data:qs.stringify(data),
    })
}
/**
 *
 * @param {roomId} params
 * @returns 房间号
 * @description 通用图片上传
 */
 export function deviceupload(data) {
    return https({
        url:rootApi + '/v2/device/upload',
        method: "post",
       data:qs.stringify(data),
    })
}

/**
 *
 * @param {roomId} params
 * @returns 房间号
 * @description 申请主播
 */
 export function hostapply(data) {
    return https({
        url:rootApi + '/v2/host/apply',
        method: "post",
        data,
    })
}



/**
 *
 * @param {roomId} params
 * @returns
 * @description 获取主播申请审核状态
 */
export function reviewstatus(params) {
    return https({
        url:rootApi+ '/v1/profile/review/status',
        method: "get",
        authToken:true,
        params,
    })
}



/**
 *
 * @param {roomId} params
 * @returns 房间号
 * @description 获取红包列表
 */
export function envelope(params) {
    requestLog(params,'/v1/envelope')
    return https({
        url:rootApi + '/v1/envelope',
        method: "get",
        params,
    })
}
/**
 *
 * @param {roomId} params
 * @returns 房间号
 * @description 查询用户信息
 */
export function getUserInfo(params) {
    return https({
        url:rootApi + '/v1/profile/user',
        method: "get",
        params,
    })
}


/**
 *
 * @param {roomId} params
 * @returns 房间号
 * @description 关注用户
 */
export function followUser(data) {
    return https({
        url:rootApi + '/v1/relation/follow',
        method: "post",
        data:qs.stringify(data),
    })
}

/**
 *
 * @param {roomId} params
 * @returns 房间号
 * @description 取消关注用户
 */
export function unfollowUser(data) {
    return https({
        url:rootApi + '/v1/relation/unfollow',
        method: "post",
        data:qs.stringify(data),
    })
}



/**
 *
 * @param {roomId} params
 * @returns 房间号
 * @description 查询用户关注
 */
export function getUserfollow(params) {
    return https({
        url:rootApi + '/v1/relation/follow',
        method: "get",
        params,
    })
}


/**
 *
 * @param {roomId} params
 * @returns 房间号
 * @description 查询用户余额
 */
export function getUserwallet(params) {
    return https({
        url:rootApi + '/v1/wallet/info',
        method: "get",
        params,
    })
}

// 敏感词
/**
 *
 * @param {roomId} params
 * @returns 房间号
 * @description 获取全部敏感词
 */
 export function sensitiveword(params) {
    return https({
        url:rootApi + '/v1/sensitive/word',
        method: "get",
        params,
    })
}


// 敏感词
/**
 *
 * @param {roomId} params
 * @returns 房间号
 * @description 直播间公告
 */
 export function roomnotice(params) {
    return https({
        url:rootApi + '/v1/setting/notice',
        method: "get",
        params,
    })
}

/**
 *
 * @param {roomId} params
 * @returns 房间号
 * @description 获取快捷礼物
 */
 export function quickgift(params) {
    return https({
        url:rootApi + '/v1/quick/gift',
        method: "get",
        params,
    })
}
// 发送弹幕

/**
 *
 * @param {roomId} params
 * @returns 房间号
 * @description 修改昵称
 */
export function roomsendMsg(data) {
    return https({
        url:rootApi + '/v1/room/sendMsg',
        method: "post",
        transformRequest: [
            function (data) {
                //在请求之前对data传参进行格式转换
                data = qs.stringify(data);
                return data;
            },
        ],
        data,
    })
}

/**
 *
 * @param {roomId} params
 * @returns 房间号
 * @description 送礼
 */
export function liveEnd(data) {
    return https({
        url:rootApi + '/v1/live/end',
        method: "post",
        data:qs.stringify(data),
    })
}

/**
 *
 * @param {roomId} params
 * @returns 房间号
 * @description 送礼
 */
export function giftsend(data) {
    return https({
        url:rootApi + '/v1/gift/send',
        method: "post",
        data:qs.stringify(data),
    })
}


/**
 *
 * @param {roomId} params
 * @returns 房间号
 * @description 禁言
 */
export function usermute(data) {
    return https({
        url:rootApi + '/v1/manage/user/mute',
        method: "post",
        data:qs.stringify(data),
    })
}


/**
 *
 * @param {roomId} params
 * @returns 房间号
 * @description 解禁
 */
export function userunmute(data) {
    return https({
        url:rootApi + '/v1/manage/user/unmute',
        method: "post",
        data:qs.stringify(data),
    })
}


/**
 *
 * @param {roomId} params
 * @returns 房间号
 * @description 超管封禁用户
 */
export function userStartmute(data) {
    return https({
        url:rootApi + '/v1/manage/user/block',
        method: "post",
        data:qs.stringify(data),
    })
}

/**
 *
 * @param {roomId} params
 * @returns 房间号
 * @description 修改昵称
 */
export function modifyNickname(data) {
    return https({
        url:rootApi + '/v1/profile/modifyNickname',
        method: "post",
        data,
    })
}

/**
 *
 * @param {roomId} params
 * @returns 房间号
 * @description 修改用户地区,性别,生日,简介
 */
export function modifyEx(data) {
    return https({
        url:rootApi + '/v1/profile/modifyEx',
        method: "post",
        headers:{
            "Content-Type": "application/x-www-form-urlencoded",
        },
        transformRequest: [
            function (data) {
                //在请求之前对data传参进行格式转换
                data = qs.stringify(data);
                return data;
            },
        ],
        data,
    })
}
/**
 *
 * @param {roomId} params
 * @returns 房间号
 * @description 获取全部快捷弹幕
 */
 export function barrageword(params) {
    return https({
        url:rootApi + '/v1/quick/barrage',
        method: "get",
        params,
    })
}

/**
 *
 * @param {roomId} params
 * @returns 房间号
 * @description  获取一级直播分类
 */
 export function categoriesList(params) {
    return https({
        url:rootApi + '/v1/list/categories',
        method: "get",
        params,
    })
}

/**
 *
 * @param {roomId} params
 * @returns 房间号
 * @description  获取全部直播分类
 */
 export function categorieAllList (params) {
    return https({
        url:rootApi + '/v1/list/categories/all',
        method: "get",
        params,
    })
}






/**
 *
 * @param {roomId} params
 * @returns 房间号
 * @description 分类轮播图
 */
 export function banners(params) {
    return https({
        url:rootApi + '/v1/list/banners',
        method: "get",
        params,
    })
}



/**
 *
 * @param {roomId} params
 * @returns 房间号
 * @description 首页榜单
 */
 export function homerank(params) {
    return https({
        url:rootApi + '/v2/list/home/rank',
        method: "get",
        params,
    })
}


/**
 *
 * @param {roomId} params
 * @returns 房间号
 * @description 房间信息
 */
 export function roomInfo(params) {
    return https({
        url:rootApi + '/v1/room/info',
        method: "get",
        versionCode:110,
        params,
    })
}

/**
 *
 * @param {roomId} params
 * @returns 房间号
 * @description 房间信息-历史聊天
 */
 export function historyMsg(params) {
    return https({
        url:rootApi + '/v2/room/historyMsg',
        method: "get",
        params,
    })
}



/**
 *
 * @param {roomId} params
 * @returns 房间号
 * @description 获取红包列表
 */
export function incomedetail(params) {
    return https({
        url:rootApi + '/v1/wallet/income/detail',
        method: "get",
        params,
    })
}


/**
 *
 * @param {roomId} params
 * @returns 房间号
 * @description 获取红包列表
 */
export function walletdetail(params) {
    requestLog(params,'/v1/wallet/detail')
    return https({
        url:rootApi + '/v1/wallet/detail',
        method: "get",
        params,
    })
}
/**
 *
 * @param {roomId} params
 * @returns 房间号
 * @description 设置权限等级
 */
export function getLevel(params) {
    requestLog(params,'/v1/room/rule/level')
    return https({
        url:rootApi + '/v1/room/rule/level',
        method: "get",
        params,
    })
}




/**
 *
 * @param {roomId} params
 * @returns 房间号
 * @description 设置权限等级
 */
export function setLevel(params) {
    requestLog(params,'/v1/room/rule/level')
    return https({
        url:rootApi + '/v1/room/rule/level',
        method: "post",
        params,
    })
}


/**
 *
 * @param {*} data
 * @returns
 *
 *
 */
 export function roomJoin(data) {
    return https({
        url:rootApi + '/v1/room/join?'+ qs.stringify(data),
        method: "post",
        headers:{
            "Content-Type": "application/x-www-form-urlencoded",
        },
        data:{},
        transformRequest: [
            function (data) {
                //在请求之前对data传参进行格式转换
                data = qs.stringify(data);
                console.log(data);
                return data;
            },
            ],
    })
}

/**
 *
 * @param {roomId,orderId} data
 * @returns 房间号id,红包id
 * @description 五分钟请求一次 -- 此处请求多了服务器会崩
 */
// export function watchtick(data) {
//     return https({
//         url:rootApi + '/v1/room/watch/tick',
//         method: "post",
//         headers:{
//             "Content-Type": "application/x-www-form-urlencoded",
//         },
//         transformRequest: [
//             function (data) {
//                 //在请求之前对data传参进行格式转换
//                 data = qs.stringify(data);
//                 console.log(data);
//                 return data;
//             },
//             ],
//         data,
//     })
// }

/**
 *
 * @param {roomId,orderId} data
 * @returns 房间号id,红包id
 * @description 点击抢红包
 */
export function snatchnvelope(data) {
    requestLog(data,'/v1/envelope')
    return https({
        url:rootApi + '/v1/envelope',
        method: "post",
        headers:{
            "Content-Type": "application/x-www-form-urlencoded",
        },
        transformRequest: [
            function (data) {
                //在请求之前对data传参进行格式转换
                data = qs.stringify(data);
                console.log(data);
                return data;
            },
            ],
        data,
    })
}



// WEBPACK FOOTER //
// ./src/api/lz.js